import { useAuth0 } from '@auth0/auth0-react';

interface AccessDeniedProps {
    message?: string;
}

export const AccessDenied: React.FC<AccessDeniedProps> = ({
    message = "You don't have permission to access this application.",
}) => {
    const { logout } = useAuth0();

    return (
        <div className="h-screen w-screen flex items-center justify-center bg-gradient-to-br from-neutral-50 via-white to-red-50 p-4">
            <div className="max-w-md w-full space-y-8">
                <div className="text-center space-y-6">
                    <div className="flex items-center justify-center space-x-2 mb-6">
                        <div className="w-12 h-12 bg-red-500 rounded-lg flex items-center justify-center">
                            <svg
                                className="w-6 h-6 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.728-.833-2.498 0L4.316 16.5c-.77.833.192 2.5 1.732 2.5z"
                                />
                            </svg>
                        </div>
                        <span className="text-2xl font-bold text-neutral-900">WEVO</span>
                    </div>

                    <div className="space-y-4">
                        <h1 className="text-3xl sm:text-4xl font-bold text-neutral-900">
                            Access Denied
                        </h1>
                        <p className="text-base sm:text-lg text-neutral-600">{message}</p>
                        <p className="text-sm text-neutral-500">
                            If you believe this is an error, please contact your system
                            administrator to request access to the management portal.
                        </p>
                    </div>
                </div>

                <div className="mt-8 space-y-3">
                    <button
                        onClick={() =>
                            logout({ logoutParams: { returnTo: window.location.origin } })
                        }
                        className="w-full bg-neutral-600 hover:bg-neutral-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors duration-200 shadow-sm hover:shadow-md"
                    >
                        Sign Out
                    </button>
                    <p className="text-xs text-center text-neutral-400">
                        You may try signing in with a different account that has administrator
                        privileges.
                    </p>
                </div>
            </div>
        </div>
    );
};
